export default __webpack_public_path__ + "static/media/hero-video-mobile-safari-es.d7622e93.mp4";